/* eslint-disable max-lines-per-function */
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Button,
  Drawer,
  DrawerContent,
  DrawerTrigger,
} from '@e2n/ui';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react/jsx-runtime';
import { KalenderByArbeitsbereicheStation } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByArbeitsbereiche/KalenderStation';
import { KalenderArbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByArbeitsbereiche/KalenderArbeitsbereich';

export function StationArbeitsbereichCard({
  kalenderStation,
  arbeitsbereich,
}: {
  kalenderStation: KalenderByArbeitsbereicheStation;
  arbeitsbereich: KalenderArbeitsbereich;
}) {
  const { t } = useTranslation();
  const mitarbeiterInfo =
    dayjs(kalenderStation.station.von).format('DD.MM.YYYY') +
    ' – ' +
    dayjs(kalenderStation.station.bis).format('DD.MM.YYYY') +
    ' ⋅ ' +
    kalenderStation.mitarbeiter.length +
    ' ' +
    t('entities.employee');

  return (
    <div className="bg-white p-4 rounded-md flex justify-between items-center">
      <div className="flex flex-col gap-2">
        <div className="flex gap-2 items-center">
          <FontAwesomeIcon
            className="text-xs"
            icon={faCircle}
            color={arbeitsbereich.getBorderColor()}
          />
          <div className="text-sm font-semibold">{arbeitsbereich.name}</div>
        </div>
        <div className="text-xs text-neutrals-800">{mitarbeiterInfo}</div>
      </div>
      <Drawer>
        <DrawerTrigger>
          <Button
            variant="icon"
            size="icon"
            className="text-neutrals-700 text-xl">
            <FontAwesomeIcon icon={faChevronRight} />
          </Button>
        </DrawerTrigger>
        <DrawerContent>
          <div className="flex flex-col gap-5 p-4">
            <div className="flex flex-col">
              <div className="flex gap-2 items-center">
                <FontAwesomeIcon
                  icon={faCircle}
                  color={arbeitsbereich.getBorderColor()}
                  className='text-xs'
                />
                <div className="text-xl font-bold">{arbeitsbereich.name}</div>
              </div>
              <div className="text-sm text-neutrals-800">{mitarbeiterInfo}</div>
            </div>
            {kalenderStation.mitarbeiter.map((m, index) => (
              <Fragment key={m.id}>
                <div className="flex gap-3 items-center">
                  <Avatar>
                    <AvatarImage
                      alt={m.vorname + ' ' + m.nachname}
                      src={m.imgUrl}
                    />
                    <AvatarFallback>
                      {m.vorname[0].toUpperCase() + m.nachname[0].toUpperCase()}
                    </AvatarFallback>
                  </Avatar>
                  <div className="flex flex-col gap-1">
                    <div className="text-sm">
                      {m.vorname + ' ' + m.nachname}
                    </div>
                    <div className="text-xs text-neutrals-700">
                      {m.lehrjahr + ' ⋅ ' + m.beruf.abkuerzung}
                    </div>
                  </div>
                </div>
                {index < kalenderStation.mitarbeiter.length - 1 && (
                  <div className="w-full bg-neutrals-200 h-px"></div>
                )}
              </Fragment>
            ))}
          </div>
        </DrawerContent>
      </Drawer>
    </div>
  );
}
